import { useSelector } from 'react-redux';
import { WelletProvider } from './WelletProvider';

function ContextProvider({ children }) {
  const user = useSelector((state) => state.associates);
  const currencies = useSelector((state) => state.currency);
  const app = useSelector((state) => state.app);

  const apiUrls = {
    ticketsUrl: process.env.REACT_APP_SALES_API_URL,
  };

  const contextUser = {
    jwt: user.jwt,
  };

  const appData = {
    name: app.name,
    logo: app.logoURL,
    language: app.language,
    currencies: currencies,
  };

  return (
    <WelletProvider
      apiUrls={apiUrls}
      user={contextUser}
      currencies={currencies}
      app={appData}
      redirectPathWhenUnauthorized='/'
    >
      {children}
    </WelletProvider>
  );
}

export default ContextProvider;
